/* eslint-disable */
import Api from '@/api/services/Api';

const route = '/empleado/cantidad'

export default {
    getEmpleadosTotal: (customfilter) => Api().get(`${route}?${customfilter}`) //empleados totales con parametros
}
